import { useState, useEffect } from 'react';
import { getModelVersionIntervals } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useIntervals = (modelVersionId, roleId, showAll = true) => {
  const dispatch = useDispatch();
  const [intervals, setIntervals] = useState([]);

  useEffect(() => {
    const loadIntervals = async () => {
      // Reset intervals to empty if modelVersionId is missing
      if (!modelVersionId) {
        setIntervals([]);
        return;
      }

      try {
        const response = await getModelVersionIntervals({ 
          modelVersionId,
          roleId: roleId || ''
        });
        
        let updatedIntervals = []; // Default to empty
        if (response?.status) {
          const fetchedIntervals = response.data || [];
          // Conditionally add 'Show All' only if showAll is true AND intervals exist
          updatedIntervals = (showAll && fetchedIntervals.length > 0)
            ? [SHOW_ALL_OPTION, ...fetchedIntervals]
            : fetchedIntervals;
        }
        setIntervals(updatedIntervals); // Set state based on fetch result
      } catch (error) {
        dispatch(showError('Failed to load intervals'));
        setIntervals([]); // Reset on error
      }
    };
    
    loadIntervals();
  }, [modelVersionId, roleId, showAll]);

  return intervals;
}; 